import http from "./http";
var baseUrl = "/common-web" ;//

//查询审批列表接口
const getApproveListService = param => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/approve/queryApproveProcess", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询审批流-不包含历史操作记录
const getRealApproveListService = param => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/approve/queryRealApproveProcess", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const queryRealApproveProcessSign = (params) => {
  return new Promise((resolve, reject) => {
    http.get("/common-web/approve/queryRealApproveProcessSign", params, true).then(result => {
      resolve(result);
    }).catch(error => {
      reject(error)
    })
  })
}

//查询当前审批流接口
const getCurrentApproveListService = param => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/approve/queryCurrentApproveProcess", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//审批供应商接口
const confirmSupplierApproveServices = param => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/submitApproveProcess", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//撤回审批对象
const recallSupplierServices = param => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/recall", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//创建审批流
const saveSupplierApproveService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/createApproveProcess", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//提交审批，修改审批流状态
const updateApproveProcessStatusService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/updateApproveProcessStatus", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//重置审批流状态
const resetApproveProcessStatusService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/resetApproveProcess", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export {
  
//审批流相关接口
saveSupplierApproveService,
updateApproveProcessStatusService,
resetApproveProcessStatusService,
getApproveListService,
getRealApproveListService,
confirmSupplierApproveServices,
recallSupplierServices,  //撤回审批对象
getCurrentApproveListService,  //查询当前审批流
queryRealApproveProcessSign
};
